/**
 * Quantidade vem como f64 do artefato do motor IFC. Arredondar em 3 casas e
 * cortar zeros à direita evita a poluição de `12.340000000000002` sem perder
 * precisão útil (mm em valores em metro).
 *
 * Vale tanto para o valor de um elemento quanto para o TOTAL de uma seleção —
 * a soma de vários f64 acumula o mesmo lixo de ponto flutuante.
 */
export const formatQuantity = (value: string): string => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) { return value; }
  return String(Math.round(parsed * 1000) / 1000);
};
